/**
 * Bloomreach subscriber for the generic tracking emitter.
 *
 * Maps vendor-agnostic business events to Bloomreach SDK calls.
 * Add new event mappings here as tracking requirements are defined.
 */
import { emitter, EmitterEvent } from '../emitter';
import { anonymizeBloomreach, trackBloomreach } from './bloomreachClient';
import { BloomreachEventNames } from './constants';
const EVENT_MAP = {
    [EmitterEvent.ADD_TO_BASKET]: data => {
        trackBloomreach(BloomreachEventNames.ADD_TO_BASKET, { sku: data.sku, quantity: data.quantity });
    },
    [EmitterEvent.LOGOUT]: () => {
        anonymizeBloomreach();
    },
};
let subscribed = false;
/** Subscribes to the generic tracking emitter. */
export const subscribeBloomreachToTracking = () => {
    if (subscribed) {
        return;
    }
    subscribed = true;
    Object.entries(EVENT_MAP).forEach(([event, handler]) => {
        emitter.on(event, handler);
    });
};
/** Unsubscribes from the generic tracking emitter. */
export const unsubscribeBloomreachFromTracking = () => {
    Object.entries(EVENT_MAP).forEach(([event, handler]) => {
        emitter.off(event, handler);
    });
    subscribed = false;
};
